import React from 'react'
import { createPortal } from 'react-dom'
import Tag from '../index'

export default function TagPortal({ id } : { id: string }) {
  const Root = document.getElementById(id);

  return Root ? createPortal(<Tag />, Root) : null
}
